import { render, staticRenderFns } from "./EmbryoTransferPage.vue?vue&type=template&id=5b3a8dba&scoped=true&"
import script from "./EmbryoTransferPage.vue?vue&type=script&lang=js&"
export * from "./EmbryoTransferPage.vue?vue&type=script&lang=js&"
import style0 from "./EmbryoTransferPage.vue?vue&type=style&index=0&id=5b3a8dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a8dba",
  null
  
)

export default component.exports